<template>
  <page class="offerTableView">
    <h4>{{ $t('residences.view.availabilities') }}</h4>
    <accomodation-table :residence="selectedResidence" />
  </page>
</template>

<script>
import { mapState } from 'vuex'
import AccomodationTable from '@/components/residences/AccomodationTable'

export default {
  name: "OfferTable",
  components: {
    AccomodationTable
  },
  computed: {
    ...mapState({
      selectedResidence: state => state.residences.selectedResidence
    }),
    selectedResidenceId() {
      return this.$route.params.id
    }
  },
  async mounted() {
    if (this.selectedResidenceId) {
      await this.$store.dispatch('residences/setSelectedResidence', this.selectedResidenceId)
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.offerTableView';

#{$c} {
  & > p {
    margin-top: 0;
  }
}
</style>